
export async function checkPortfolioAuthorForUpdate(bucketIdsThatWillClose, getState, kickSubscription) {
    await kickSubscription("PORTFOLIO_AUTHOR");
    if (bucketIdsThatWillClose.size === 0) {
        return true;
    }

    // kicking subscription until open ideas does not have the bucketIds that will close
    const { portfolioAuthor } = getState();

    return !portfolioAuthor.content.openIdeas.find(idea => bucketIdsThatWillClose.has(idea.bucketId));
}